<div class="notif-panel">
	<div class="notif-panel-header">
		<div class="d-flex align-items-center gap-2 min-w-0">
			@if (selected) {
				<button type="button" class="notif-back-btn" (click)="back()" title="{{ 'Indietro' | translate }}">
					<i class="pi pi-arrow-left" aria-hidden="true"></i>
				</button>
			}
			<span class="notif-panel-title">{{ (selected ? 'Notifica' : 'Notifiche') | translate }}</span>
		</div>
		@if (!selected) {
			<div class="notif-panel-actions">
				@if (unreadCount > 0) {
					<p-button label="{{ 'Segna tutte come lette' | translate }}" icon="pi pi-check-circle" [text]="true" size="small" [loading]="markingAll" (onClick)="markAllRead()"></p-button>
				}
				@if (isAdmin) {
					<p-button label="{{ 'Gestione' | translate }}" icon="pi pi-cog" [text]="true" size="small" (onClick)="goToList()"></p-button>
				}
			</div>
		}
	</div>

	<div class="notif-panel-body">
		@if (selected) {
			<!-- Vista dettaglio inline -->
			<div class="notif-detail">
				<h6 class="notif-detail-title">{{ selected.usrnot_title }}</h6>
				<div class="notif-detail-meta">
					<span><i class="pi pi-calendar"></i> {{ selected.usrnot_dateins | date: 'dd/MM/yyyy HH:mm' }}</span>
					<span><i [class]="getIcon(selected)"></i> {{ getChannelLabel(selected) }}</span>
				</div>

				@if (selected.usrnot_message_html_it) {
					<div class="notif-detail-html" [innerHTML]="selected.usrnot_message_html_it"></div>
				} @else if (selected.usrnot_message_it) {
					<div class="notif-detail-text">{{ selected.usrnot_message_it }}</div>
				} @else {
					<p class="notif-detail-empty">{{ 'Nessun messaggio' | translate }}</p>
				}

				@if (selected.usrnot_image) {
					<img [src]="getImageUrl(selected.usrnot_image)" class="notif-detail-image" alt="immagine notifica" />
				}

				<!-- Scelta del canale per questo tipo di notifica (stesse preferenze del profilo) -->
				@if (selectedPref; as pref) {
					<div class="notif-pref">
						<div class="notif-pref-head">
							<span class="notif-pref-title"><i class="pi pi-sliders-h" aria-hidden="true"></i> {{ 'Come vuoi ricevere queste notifiche?' | translate }}</span>
							@if (prefSaving) {
								<span class="notif-pref-state"><i class="pi pi-spin pi-spinner" aria-hidden="true"></i></span>
							} @else if (prefSaved) {
								<span class="notif-pref-state saved"><i class="pi pi-check" aria-hidden="true"></i> {{ 'Preferenza salvata' | translate }}</span>
							}
						</div>
						<div class="notif-pref-desc">{{ pref.umst_desc }}</div>
						<p-selectbutton [options]="channelOptions" [(ngModel)]="pref.effective_channel" optionValue="value" [allowEmpty]="false" size="small" [disabled]="prefSaving" (onChange)="onChannelChange(pref)">
							<ng-template let-opt #item>
								<i [class]="opt.icon" aria-hidden="true"></i>
								<span class="ms-1">{{ opt.label | translate }}</span>
							</ng-template>
						</p-selectbutton>
					</div>
				} @else {
					<button type="button" class="notif-pref-link" (click)="goToProfile()">
						<i class="pi pi-sliders-h" aria-hidden="true"></i> {{ 'Gestisci le preferenze notifiche nel profilo' | translate }}
					</button>
				}
			</div>
		} @else {
			<!-- Vista lista -->
			@if (loading && list.length === 0) {
				<div class="notif-loading"><i class="pi pi-spin pi-spinner"></i></div>
			}

			@if (!loading && list.length === 0) {
				<div class="notif-empty">
					<i class="pi pi-bell-slash" aria-hidden="true"></i>
					<p>{{ 'Nessuna notifica' | translate }}</p>
				</div>
			}

			@for (item of list; track item.usrnot_id) {
				<button type="button" class="notif-item" [class.unread]="isUnread(item)" (click)="onItemClick(item)">
					<span class="notif-item-icon"><i [class]="getIcon(item)" aria-hidden="true"></i></span>
					<span class="notif-item-content">
						<span class="notif-item-title">{{ item.usrnot_title }}</span>
						<span class="notif-item-text">{{ getMessage(item) }}</span>
					</span>
					<span class="notif-item-meta">
						<span class="notif-item-time">{{ getTimeAgo(item.usrnot_dateins) }}</span>
						@if (isUnread(item)) {
							<span class="notif-item-dot" aria-hidden="true"></span>
						}
					</span>
				</button>
			}
		}
	</div>
</div>
